<template>
  <b-form-group>
    <template v-slot:label>
      CNPJ: 
      <span v-if="validadoreceita" style="background-color: #f3f6f9; padding: 4px 4px; margin-left: 5px; border-radius: 6px;">
        <img src="media/icons/valid.png" style="width: 24px; margin-bottom: 2px;" /> Validado
      </span>
      <a
        v-if="!validadoreceita"
        href="javascript:;"
        @click="validarCNPJReceita"
        class="btn btn-light-primary font-weight-bolder mr-2"
        :disabled="loading" 
        style="margin: 0; padding: 0px 4px; font-size: 10px; margin-left: 4px;"
      >
        <b-spinner
          v-if="loading"
          small
          style="margin-bottom: 2px; margin-right: 3px;"
        ></b-spinner>
        <i v-if="!loading" class="ki ki-check icon-sm"></i> Validar Receita
      </a>
    </template>
    <b-form-input
      type="text"
      v-model="valor"
      placeholder="CNPJ"
      v-mask="'##.###.###/####-##'"
      :state="valid"
      @blur="validar"
    ></b-form-input>
    <b-form-invalid-feedback>
      O CNPJ informado não é válido.
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<style lang="scss" scoped></style>

<script>
import Swal from "sweetalert2";

export default {
  name: "InputCNPJ",
  data() {
    return {
      valid: null,
      loading: false
    };
  },
  computed: {
    valor: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  props: ["value", "validadoreceita"],
  methods: {
    validar() {
      let cnpj = this.valor.replace(/[^\d]+/g, "");

      this.valid = null;

      if (cnpj == "") this.valid = false;

      if (cnpj.length != 14) this.valid = false;

      if (
        cnpj == "00000000000000" ||
        cnpj == "11111111111111" ||
        cnpj == "22222222222222" ||
        cnpj == "33333333333333" ||
        cnpj == "44444444444444" ||
        cnpj == "55555555555555" ||
        cnpj == "66666666666666" ||
        cnpj == "77777777777777" ||
        cnpj == "88888888888888" ||
        cnpj == "99999999999999"
      )
        this.valid = false;

      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;
      let i = 0;

      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }

      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

      if (resultado != digitos.charAt(0)) this.valid = false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;

      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }

      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);

      if (resultado != digitos.charAt(1)) this.valid = false;

      if (this.valid == null) this.valid = true;

      return this.valid;
    },
    async validarCNPJReceita() {
      if(this.validar()) {
        this.loading = true;

        let retorno = await this.$store.dispatch("getCNPJCaptcha", {});
        let resultadoValidacao = {};

        await Swal.fire({
          imageUrl: retorno.captcha,
          title: 'Confirme o captcha:',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: false,
          confirmButtonText: 'Enviar',
          showLoaderOnConfirm: true,
          preConfirm: (captcha) => {
            return this.$store.dispatch("getCNPJValidacao", {
              cnpj: this.valor.replace(/\D/g, ""),
              captcha: captcha,
              session: retorno.PHPSESSID
            }).then(response => {
              resultadoValidacao = response;
            });
          },
          allowOutsideClick: () => !Swal.isLoading()
        });

        this.loading = false;

        if(resultadoValidacao.status == "OK") {
          Swal.fire({
            title: "Aviso",
            text: "Emitente validado com sucesso.",
            icon: "success",
            timer: 3000,
            showConfirmButton: false
          });

          this.$emit("validacaoReceitaCNPJ", resultadoValidacao);
        } else {
          Swal.fire({
            title: "Aviso",
            text: "Não foi possível validar. Tente novamente mais tarde.",
            icon: "error",
            timer: 3000,
            showConfirmButton: false
          });
        }
      } else {
        Swal.fire({
          title: "Aviso",
          text: "O CNPJ informado não é válido.",
          icon: "error",
          timer: 3000,
          showConfirmButton: false
        });
      }
    }
  }
};
</script>
